
import { bindActionCreators } from 'redux';
import { connect }            from 'react-redux';
import * as actions           from '../../../redux/modules/actions';
import DailyRevenue       from './revenue';

const mapStateToProps = (state) => {
  return {
    currentView:  state.views.currentView,
    statsTable:             state.statsTable,
    scoreCard:              state.scoreCard,
    statsGraph:             state.statsGraph,   
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions : bindActionCreators(
      {
        enterPage: actions.enterPage,
        leavePage: actions.leavePage,
        fetchStatsGraphDataIfNeeded:  actions.fetchStatsGraphDataIfNeeded,                        
        fetchStatsTableDataIfNeeded:  actions.fetchStatsTableDataIfNeeded,
        fetchScoreCardDataIfNeeded:   actions.fetchScoreCardDataIfNeeded

      },
      dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DailyRevenue);



// WEBPACK FOOTER //
// ./src/app/views/partner/partnerrevenue/index.js